import { render } from "./Subscription.vue?vue&type=template&id=390dca31&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=390dca31&scoped=true&lang=css"
import "./Subscription.vue?vue&type=style&index=1&id=390dca31&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390dca31"]])

export default __exports__